module.exports = __webpack_public_path__ + "img/TEALS.b1a6ecaa.png";